import React from 'react';
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';
import 'rc-tabs/assets/index.css';
import { isEqual, isEmpty } from 'lodash';
import './Tabstyle_31.css';

//标准图标样式
export default class Tabstyle_31 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            tabid: this.props.tabid
        }
        this.handleTabData = this.handleTabData.bind(this);
    }

    handleTabData(tabid){
        const { datas={} } = this.props;
        const { handleTabData={} } = datas;
        handleTabData(tabid);
        this.setState({
            tabid: tabid
        })
    }

    componentWillReceiveProps(nextProps){
        const { tabid } = this.state;
        if(!isEqual(tabid, nextProps.datas.currentTab)){
            this.setState({
                tabid: nextProps.datas.currentTab
            })
        }
    }

   
    
    render(){     
        const { datas={}, fontStyle, ebaseid = '' } = this.props;
        const { tabid } = this.state;
        const { isShowSettingShowType='0' } = datas;
        if(isEmpty(datas)) return <div/>;
        const { currentTab='1', tabids = [], titles = [], methodvalue,tabwidth,counts } = datas;
        let style = {marginLeft: '10px', marginRight: '10px',height:'100%'};
        let style1 = {width: tabwidth + 'px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'block',padding:'0px 5px',height:'100%'};
        let titleStyle = {width: '100%'};
        let tHtml_new = (
            <div className='commonTab Tabstyle_31' id='Tabstyle_31'>
                <Tabs ecId={`${this && this.props && this.props.ecId || ''}_Tabs@zv7vyv`}
                 activeKey={tabid}
                 renderTabBar={()=><ScrollableInkTabBar ecId={`${this && this.props && this.props.ecId || ''}_ScrollableInkTabBar@htguei`} />}
                 renderTabContent={()=><TabContent ecId={`${this && this.props && this.props.ecId || ''}_TabContent@kkbfiu`} />}
                 className="tabcontainer tab2"
                 style={titleStyle}
                >
                {
                    titles.map((title, i)=> {
                        if ((ebaseid == '8') && counts && counts[i] !== -1 && counts[i] !== '' && counts[i] !== null) {
                            if(counts[i] > 99){
                                title +='(99+)';
                            }else {
                                title +=' (' + counts[i] + ')';
                            }
                        }else if (ebaseid == 'blogStatus' && counts && '0'!== counts[i]) {
                            title += ' (' + counts[i] + ')';
                        }else if(ebaseid == '7_DY'&& counts && '0'!== counts[i]){
                            title += ' (' + counts[i].noReadNum + ')';
                        }else if(isShowSettingShowType == '1' && ebaseid == '7'&& counts && counts[i] && counts[i].noReadNum){
                            title += ' (' + counts[i].noReadNum + ')';
                        }else if(ebaseid == '7'&& counts && counts[i] && counts[i].isHaveNoRead && counts[i].isHaveNoRead == '1'){
                            title =  title;
                        }
                        const tdStyle=tabids[i] == tabid ? {width: 'auto', verticalAlign: 'top',backgroundSize: '100% 100%', height: '50px', lineHeight: '50px', paddingTop: '0px !important','border-bottom':'2.5px solid #00A9FF'}:
                        {width: 'auto', verticalAlign: 'top',backgroundSize: '100% 100%', height: '50px', lineHeight: '50px', paddingTop: '0px !important'};
                        const tdStyle1=tabids[i] == tabid ? {width: 'auto', paddingRight: '10px', verticalAlign: 'top',backgroundSize: '100% 100%', height: '50px', lineHeight: '50px', paddingTop: '0px !important','border-bottom':'2.5px solid #00A9FF'}:
                        {width: 'auto', paddingRight: '10px', verticalAlign: 'top',backgroundSize: '100% 100%', height: '50px', lineHeight: '50px', paddingTop: '0px !important'};
                        const className = tabids[i] == tabid ? `tab2selected wea-f${fontStyle.tab1fontsize || 12}` : `tab2unselected wea-f${fontStyle.tab2fontsize || 12}`;
                        const pointClassName = ebaseid == '7'&& counts && counts[i] && counts[i].isHaveNoRead && counts[i].isHaveNoRead == '1' ? 'portal-new-unreadpoint' : '';
                        let tabTextStyle=pointClassName==''?{display:'inline-block',width:'100%',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}:{display:'inline-block',width:'calc(100% - 10px)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}
                    return <TabPane ecId={`${this && this.props && this.props.ecId || ''}_TabPane@dem4pc@${tabids[i]}`} key={tabids[i]} style={{width: '200px'}} tab={<div title={title} className={className} style={methodvalue == '2' ? tdStyle1 : tdStyle} data-tabid={tabids[i]}  onClick={() => this.handleTabData(tabids[i])}>
                                    <div style={methodvalue == '2' ? style:style1}>
                                        <div style={tabTextStyle}>{title}</div>
                                        <div className={pointClassName} style={{position:'relative',top:'-22px'}}></div>
                                    </div>
                                </div>}></TabPane>
                    })
                }
            </Tabs>
            </div>
        )
        return tHtml_new;
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/tabstyle/31/Tabstyle_31.js